/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2019 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import SymbolSubstitutionBase, { SymbolStack } from "./SymbolSubstitutionBase";
import PlayResultComponent from "../Server/PlayResultComponent";
import InjectableComponent from "../Utility/Component/ComponentReference/InjectableComponent";
import GameSetup from "../Game/GameSetup";
import { IPatternStacksData } from "../Server/Object/BaseGamePlayResult";

const property = cc._decorator.property;

@cc._decorator.ccclass
export default class PatternStackSubstitution extends SymbolSubstitutionBase
{
    @property({ type: SymbolStack, visible: true })
    private _substitutionSymbol: SymbolStack = null;

    @property({ visible: true })
    private _defaultSymbol: string = "A";

    private _gameSetupRef: InjectableComponent<GameSetup> = new InjectableComponent();
    protected get gameSetup(): GameSetup { return this._gameSetupRef.Value; }

    private _playResultRef: InjectableComponent<PlayResultComponent> = new InjectableComponent();
    protected get playResult(): PlayResultComponent { return this._playResultRef.Value; }

    protected setContexts(): void
    {
        this._gameSetupRef.SetContext(GameSetup);
        this._playResultRef.SetContext(PlayResultComponent);
    }

    public get IsContinuous(): boolean { return true; }

    public SubstituteReelSymbols(reelStrip: string[], reelIndex: number): string[]
    {
        const newStrip: string[] = [];
        let subData: IPatternStacksData = null;

        if (this.playResult.PlayState)
        {
            if (this.playResult.IsBonusSpinActive())
            {
                subData = this.playResult.PlayState.playResult.BonusGamePlayResult.PatternStacksData;
            }
            else
            {
                subData = this.playResult.PlayState.playResult.BaseGamePlayResult.PatternStacksData;
            }
        }
        if (subData === null)
        {
            subData = this.gameSetup.LastPlayState.playResult.BaseGamePlayResult.PatternStacksData;
        }

        for (let symbol of reelStrip)
        {
            if (symbol === this._substitutionSymbol.StackSymbol)
            {
                newStrip.push(subData ? subData.aSymbols[subData.aPattern[reelIndex]] : this._defaultSymbol);
            }
            else
            {
                newStrip.push(symbol);
            }
        }

        return newStrip;
    }
}
